import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Suspense, lazy } from 'react';
import { LanguageProvider } from './i18n';
import { SiteContentProvider } from './content/SiteContentProvider';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const FeaturesPage = lazy(() => import('./pages/FeaturesPage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const HowItWorksPage = lazy(() => import('./pages/HowItWorksPage'));
const SolutionsPage = lazy(() => import('./pages/SolutionsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const ComplaintNewPage = lazy(() => import('./pages/ComplaintNewPage'));
const ComplaintTrackPage = lazy(() => import('./pages/ComplaintTrackPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const SignInPage = lazy(() => import('./pages/LoginPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
    </div>
  );
}

const LazyRoutes = () => (
  <Suspense fallback={<PageFallback />}>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/features" element={<FeaturesPage />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/solutions" element={<SolutionsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/complaint/new" element={<ComplaintNewPage />} />
      <Route path="/complaint/track" element={<ComplaintTrackPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/login" element={<SignInPage />} />
      <Route path="/sign-in" element={<SignInPage />} />
      {/*
        /admin → nginx handles the 301 redirect to /admin/
        (see nginx/swachhbharat.conf: location = /admin)
        No SPA route needed here; the public website's root at /var/www/swachh-bharat
        only serves the citizen-facing site. The admin dashboard is at /admin-dashboard/
        on disk and served via the nginx ^~ /admin/ alias.
      */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Suspense>
);

export default function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <SiteContentProvider>
          <BrowserRouter>
            <LazyRoutes />
          </BrowserRouter>
        </SiteContentProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}